export default {
    buttons: {
        save: 'Sačuvaj',
    },
    fields: {
        company_role: {
            label: 'Uloga u kompaniji',
            placeholder: 'Odaberite ulogu u kompaniji',
        },
    },
    select: {
        admin: 'ADMINISTRATOR',
        user: 'KORISNIK',
    },
    errors: {
        user_cannot_change_your_role: 'Ne možete promeniti svoju ulogu',
    },
}
